import React from 'react';
import Icon from '../../../components/AppIcon';

const ChatMessage = ({ message, isUser, timestamp, showActions = false, onFollowUp, onLawyerReferral }) => {
  const formatTime = (date) => {
    return new Intl.DateTimeFormat('fa-IR', {
      hour: '2-digit',
      minute: '2-digit'
    })?.format(date);
  };

  return (
    <div className={`flex ${isUser ? 'justify-start' : 'justify-end'} mb-4`}>
      <div className={`max-w-xs sm:max-w-md lg:max-w-lg ${isUser ? 'order-2' : 'order-1'}`}>
        {/* Message Bubble */}
        <div
          className={`px-4 py-3 rounded-2xl ${
            isUser
              ? 'bg-muted text-foreground rounded-br-md'
              : 'bg-primary text-primary-foreground rounded-bl-md'
          } shadow-subtle animate-in slide-in-from-bottom-2 duration-300`}
        >
          <p className="text-sm leading-relaxed whitespace-pre-wrap">{message}</p>
        </div>

        {/* Timestamp */}
        <div className={`flex items-center mt-1 px-2 ${isUser ? 'justify-start' : 'justify-end'}`}>
          <span className="text-xs text-muted-foreground">
            {formatTime(timestamp)}
          </span>
        </div>

        {/* Action Buttons for AI Messages */}
        {!isUser && showActions && (
          <div className="flex items-center gap-2 mt-3 px-2">
            <button
              onClick={onFollowUp}
              className="inline-flex items-center px-3 py-1.5 text-xs font-medium text-primary bg-primary/10 hover:bg-primary/20 rounded-full transition-smooth focus-ring"
            >
              <Icon name="MessageCircle" size={14} className="ml-1" />
              سوال بیشتر
            </button>
            <button
              onClick={onLawyerReferral}
              className="inline-flex items-center px-3 py-1.5 text-xs font-medium text-secondary bg-secondary/10 hover:bg-secondary/20 rounded-full transition-smooth focus-ring"
            >
              <Icon name="User" size={14} className="ml-1" />
              مشاوره با وکیل
            </button>
          </div>
        )}
      </div>

      {/* Avatar */}
      <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
        isUser ? 'order-1 ml-3 bg-muted' : 'order-2 mr-3 bg-primary'
      }`}>
        <Icon 
          name={isUser ? "User" : "Scale"} 
          size={16} 
          color={isUser ? "var(--color-muted-foreground)" : "white"} 
        />
      </div>
    </div>
  );
};

export default ChatMessage;